// extracted by mini-css-extract-plugin
export default {"content":"AppDrawer_content__o4uUE","button":"AppDrawer_button__8zlFv","header":"AppDrawer_header__8tbQd"};